import { render, staticRenderFns } from "./productsLastStat.vue?vue&type=template&id=42575a9f&scoped=true"
import script from "./productsLastStat.vue?vue&type=script&lang=js"
export * from "./productsLastStat.vue?vue&type=script&lang=js"
import style0 from "./productsLastStat.vue?vue&type=style&index=0&id=42575a9f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42575a9f",
  null
  
)

export default component.exports